const EmailPreferenceTypes = {
  TEXT: 1,
  SMS: 2,
  HTML: 4
};

export default EmailPreferenceTypes;



// WEBPACK FOOTER //
// ./app/constants/EmailPreferenceTypes.js